module.exports = __webpack_public_path__ + "img/02—01—02a—Port Forwarding.d0d93dd7.jpg";